import React from "react";
import "./SearchPage.scss";

export default function SearchPage() {
  return <div>SearchPage</div>;
}
